import type { ServiceTypeEnum } from '@/shared/enums';

export enum ProfilePaths {
    Access = 'Access',
    InsurancePartnerDetails = 'InsurancePartnerDetails',
    SelectInsurancePartner = 'SelectInsurancePartner',
    TrainingProgramDetails = 'TrainingProgramDetails',
    SubscriptionDetails = 'SubscriptionDetails',
    CouponDetails = 'CouponDetails',
    MyInformation = 'MyInformation',
    Household = 'Household',
    Pets = 'Pets',
    Language = 'Language',
    Newsletter = 'Newsletter',
    DeleteAccount = 'DeleteAccount',
    OnlinePharmacy = 'OnlinePharmacy',
}

export type CouponRedemptionViewModel = {
    CouponRedemptionId: number;
    ExpiryDateString?: string;
    IsActive: boolean;
    StatusText: string;
    DiscountText: string;
    ShowDiscount: boolean;
    ConsultationsUsedText: string;
    ShowConsultationsUsed: boolean;
    CouponName?: string;
    CouponRedemptionDescription?: string;
    CouponRecipientName?: string;
    CompanyName?: string;
    ServiceTypes: ServiceTypeEnum[];
};

export type TrainingProgramViewModel = {
    UserId: number;
    Name: string;
    IsActive: boolean;
    StatusText: string;
    ExpirationDateString: string;
};

export type InsurancePartnerBenefit = {
    iconFilename?: string;
    caregiverName: string;
    services: InsurancePartnerService[];
};

export type InsurancePartnerService = {
    iconFilename: string;
    description: string;
};

export type PfaProgressCard = {
    PatientFullName?: string;
    IconFilename?: string;
    CaregiverName?: string;
    ExpiryDate?: string;
    ConsultationsAllowed?: number;
    CouponRedemptions?: number;
    InjuryDescription?: string;
};

export type InsurancePartnerOption = {
    name: string;
    logoPath: string;
    enrollmentUrl: string;
};

export type SubscriptionDetailsResponse = {
    SubscriptionId: string;
    Title: string;
    StatusText: string;
    IsActive: boolean;
    StartedOn: string;
    IsSinglePayment: boolean;
    LatestPayment: string;
    NextPayment: string;
    Price: string;
    PricePeriod: string;
    NextPaymentText: string;
    IsCancelled: boolean;
    CancelledOn: string | null;
    AllowUncancel: boolean;
    SubscriptionExpired: boolean;
    PaymentInfoLink: string | null;
    IsSubscriptionPlanActive: boolean;
    IsCoveredByCoupon: boolean;
};
